export const SET_CONSENT = 'gdpr/SET_CONSENT';

export const setConsent = consent => ({
  type: SET_CONSENT,
  consent,
});
